var _rect, _circle, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 20,
    height: 20
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#494b74",
    opacity: 0.3,
    cx: 8.333,
    cy: 8.333,
    r: 8.333,
    transform: "translate(1.667 1.667)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#3699ff",
    width: 1.667,
    height: 5.833,
    rx: 0.833,
    transform: "translate(9.167 8.333)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#494b74",
    width: 1.667,
    height: 1.667,
    rx: 0.833,
    transform: "translate(9.167 5.833)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.4e1e9e89083635f431c35b97696348f6.svg";
export { ForwardRef as ReactComponent };